export const limitText = (string = '', limit = 0) => string.substring(0, limit);

export const isTextOverLimit = (text = '', maxLenth) => {
  if (!maxLenth) {
    return false;
  }

  return text.length > maxLenth ? true : false;
};

export const nameLimiter = (text = '', maxLenth) => {
  const isOverLimit = isTextOverLimit(text, maxLenth);

  if (!isOverLimit) {
    return [text, ''];
  }

  const textArray = text.trim().split(' ');

  const firstName = textArray[0] || '';
  const lastName = textArray.length > 1 ? textArray[textArray.length - 1] : '';
  const middleNamesArray = textArray.slice(1, -1);
  const middleNamesFull = middleNamesArray.join(' ').trim('');

  let completeName = `${firstName.trim()}${
    middleNamesFull.trim() ? ` ${middleNamesFull.trim()}` : ''
  }${lastName.trim() ? ` ${lastName.trim()}` : ''}`;

  if (!isTextOverLimit(completeName, maxLenth)) {
    // Formatted name, Dotted name
    return [completeName, ''];
  }

  const middleNames = middleNamesArray
    .map((m = '') => (m.charAt(0) ? m.charAt(0) : ''))
    .join(' ')
    .trim('');

  completeName = `${firstName.trim()}${
    middleNames.trim() ? ` ${middleNames.trim()}` : ''
  }${lastName.trim() ? ` ${lastName.trim()}` : ''}`;

  if (!isTextOverLimit(completeName, maxLenth)) {
    return [completeName, ''];
  }

  completeName = `${firstName.trim()}${
    lastName.trim() ? ` ${lastName.trim()}` : ''
  }`;

  if (!isTextOverLimit(completeName, maxLenth)) {
    return [completeName, ''];
  }

  completeName = `${firstName.trim()}${
    lastName.trim() ? ` ${lastName.trim().charAt(0)}` : ''
  }`;

  if (!isTextOverLimit(completeName, maxLenth)) {
    return [completeName, ''];
  }

  completeName = `${firstName.trim()}`;

  if (!isTextOverLimit(completeName, maxLenth)) {
    return [completeName, ''];
  }

  // Formatted name, raw name, isDotted
  return [completeName, `${limitText(completeName, maxLenth - 3)}...`];
};

export const getIsValidUsernameChar = (val = '') => {
  // allowed : @, dot, hyphen, underscore, space, &
  return val.match(/[\w@.& -]/gi, '') ? true : false;
};

export const getValidUserNameOnType = (val = '') => {
  // allowed : @, dot, hyphen, underscore, space, &
  const filteredValue = val ? val.replace(/[^\w@.& -]/gi, '') : '';

  return filteredValue;
};

export const getNameInitials = (val = '') => {
  // remove anything inside parentheses
  const cleaned = val.replace(/\(.*?\)/g, '').trim();

  const name = cleaned.split(' ').filter(Boolean);

  const firstName = name[0] || '';
  const lastName = name.length > 1 ? name[name.length - 1] : '';

  const firstInitial = firstName.charAt(0) || '';
  const lastInitial = lastName.charAt(0) || '';

  return `${firstInitial}${lastInitial}`;
};

/**
 * Simplifies a name by:
 * - Trimming leading/trailing spaces
 * - Replacing multiple spaces with a single hyphen
 * - Converting all characters to lowercase
 *
 * @param {string} name - The input name string
 * @returns {string} - The simplified, URL-friendly name
 */
export function createIdFromName(name) {
  return name
    ?.trim() // Remove leading/trailing spaces
    .replace(/\s+/g, '-') // Replace one or more spaces with '-'
    .toLowerCase(); // Convert to lowercase
}

/**
 * Extracts the text inside the first pair of round brackets `()`.
 *
 * @param {string} input - The input string containing round brackets.
 * @returns {string} The extracted text inside brackets,
 * or an empty string if no match is found.
 *
 * @example
 * extractFromBrackets("MAHENDRABEN DHIRAJLAL SHAH (M346441)");
 * // Returns: "M346441"
 *
 * @example
 * extractFromBrackets("Test ()");
 * // Returns: ""
 *
 * @example
 * extractFromBrackets("No brackets here");
 * // Returns: ""
 */
export function extractFromBrackets(input) {
  const match = input.match(/\(([^)]*)\)/);
  return match ? match[1] : '';
}
